export default __webpack_public_path__ + "static/media/logo@3x 1.171e36a8.svg";